import { GetStaticProps, NextPage } from 'next';
import { useTranslation } from 'react-i18next';

import PageMeta from '@/components/app/pageMeta/PageMeta';
import SocialMeta from '@/components/app/socialMeta/SocialMeta';
import Mainpage from '@/components/showcase/page/Mainpage';
import { URL_COMPANY } from '@/constants/global';
import { logError } from '@/utils/log';
import { getPageDataByPageUID, TypePage } from '@/utils/page';
import { TypeSlice } from '@/utils/prismic';

import { PageProps } from '../[slug]';

const Page: NextPage<PageProps> = ({ pageData }) => {
  const { t } = useTranslation();
  const { title, description, ogImage, ogTitle, ogDescription } = pageData;

  const slices = pageData.slices.filter(
    ({ slice_type }) => slice_type === TypeSlice.AGENTS
  );

  return (
    <PageMeta
      title={title}
      description={description}
      socialComponent={
        <SocialMeta
          description={ogDescription || description || t('agents')}
          url={URL_COMPANY}
          title={ogTitle || title}
          picture={ogImage?.url}
        />
      }
    >
      <Mainpage pageData={{ ...pageData, slices }} />
    </PageMeta>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    const pageData: TypePage = await getPageDataByPageUID('nos-agents');

    if (!pageData.title) {
      return {
        notFound: true,
        revalidate: true
      };
    }

    return { props: { pageData }, revalidate: 15 * 60 };
  } catch (error) {
    logError('Failed to load "Nos agents" page', { error });
  }

  return {
    notFound: true,
    revalidate: true
  };
};

export default Page;
